<ng-container *ngIf="typeChange$ | async"></ng-container>
<ng-container *ngIf="countryCode$ | async"></ng-container>

<div id="register" class="flex flex-col" fusePerfectScrollbar>
  <div id="register-form-wrapper" class="flex flex-col justify-center items-center">
    <div id="register-form" *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div *ngIf="sendingData">
        <div class="progress-spinner-wrapper w-full h-full flex justify-center items-center">
          <mat-spinner></mat-spinner>
        </div>
      </div>

      <!-- LANGUAGE -->
      <button mat-button class="language-button hidden sm:block" [matMenuTriggerFor]="languageMenu">
        <div class="flex items-center justify-center">
          <img class="flag mr-2 w-4" [src]="'./assets/images/flags/' + locale + '.svg'" />
          <span class="iso text-uppercase">{{ locale }}</span>
        </div>
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button
          mat-menu-item
          *ngFor="let lang of languages"
          [routerLink]="['/' + lang.id + '/#' + getCurrentRoute()]"
          (click)="changeLanguage(lang.id)">
          <div class="flex items-center">
            <img class="flag mr-4 w-4" [src]="'./assets/images/flags/' + lang.id + '.svg'" />
            <span class="iso">{{ lang.title }}</span>
          </div>
        </button>
      </mat-menu>
      <!-- LANGUAGE / -->

      <div i18n class="title">РЕГИСТРАЦИЯ</div>

      <div>
        <form
          name="registerForm"
          [formGroup]="registerForm"
          novalidate
          (ngSubmit)="onSubmit()"
          class="flex flex-col items-start">
          <mat-form-field
            class="dense-input"
            appearance="outline"
            [class.hidden]="options?.availableClientType !== availableClientTypeEnum.All">
            <mat-label i18n>Тип клиента</mat-label>
            <mat-select #clientTypeSelect formControlName="type" required>
              <mat-option i18n [value]="0">Физическое лицо</mat-option>
              <mat-option i18n [value]="1">Юридическое лицо</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="dense-input" appearance="outline" [class.hidden]="clientTypeSelect.value !== 1">
            <mat-label i18n>Название фирмы</mat-label>
            <input matInput formControlName="companyName" />
            <mat-error i18n *ngIf="registerForm.get('companyName').hasError('maxlength')"
              >Максимальная длина
              {{ registerForm.get('companyName').getError('maxlength').requiredLength }} символов</mat-error
            >
          </mat-form-field>

          <mat-form-field class="dense-input" appearance="outline" [class.hidden]="clientTypeSelect.value !== 1">
            <mat-label i18n>ИНН</mat-label>
            <input matInput formControlName="inn" [required]="hasRequiredValidator('inn')" />
            <mat-error i18n *ngIf="registerForm.get('inn').hasError('required')">Поле не должно быть пустым</mat-error>
          </mat-form-field>

          <div class="flex gap-2">
            <mat-form-field class="dense-input flex-1" appearance="outline">
              <mat-label i18n>Фамилия</mat-label>
              <input matInput formControlName="surname" required />
              <mat-error i18n *ngIf="registerForm.get('surname').hasError('required')">Фамилия не задана</mat-error>
              <mat-error
                i18n
                *ngIf="
                  !registerForm.get('surname').hasError('required') && registerForm.get('surname').hasError('minLength')
                "
                >Минимальная длина - {{ registerForm.get('surname').getError('minlength').requiredLength }}</mat-error
              >
            </mat-form-field>

            <mat-form-field class="dense-input flex-1" appearance="outline">
              <mat-label i18n>Имя</mat-label>
              <input matInput formControlName="name" required />
              <mat-error i18n *ngIf="registerForm.get('name').hasError('required')">Имя не задано</mat-error>
              <mat-error
                i18n
                *ngIf="!registerForm.get('name').hasError('required') && registerForm.get('name').hasError('minLength')"
                >Минимальная длина - {{ registerForm.get('name').getError('minlength').requiredLength }}</mat-error
              >
            </mat-form-field>
          </div>

          <mat-form-field class="dense-input" appearance="outline">
            <mat-label i18n>Отчество</mat-label>
            <input matInput formControlName="patronymic" [required]="hasRequiredValidator('patronymic')" />
            <mat-error i18n *ngIf="registerForm.get('patronymic').hasError('required')">Отчество не задано</mat-error>
          </mat-form-field>

          <mat-form-field class="dense-input" appearance="outline">
            <mat-label i18n>Email</mat-label>
            <input type="text" matInput formControlName="email" [required]="hasRequiredValidator('email')" />
            <mat-error i18n *ngIf="registerForm.get('email').hasError('required')">Email не задан</mat-error>
            <mat-error
              i18n
              *ngIf="!registerForm.get('email').hasError('required') && registerForm.get('email').hasError('email')"
              >Пожалуйста введите действительный Email</mat-error
            >
          </mat-form-field>

          <ngx-intl-tel-input
            [cssClass]="'custom'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="adminCountry"
            [maxLength]="'15'"
            [separateDialCode]="true"
            [numberFormat]="phoneNumberFormat.National"
            name="phone"
            class="w-full"
            formControlName="phone"
            [dense]="true"
            [requiredd]="hasRequiredValidator('phone')">
          </ngx-intl-tel-input>

          <mat-form-field class="dense-input" appearance="outline" [hideRequiredMarker]="false">
            <mat-label i18n>Пароль</mat-label>
            <input matInput formControlName="password" required [type]="hidePass ? 'password' : 'text'" />
            <mat-icon matSuffix (click)="hidePass = !hidePass">
              {{ hidePass ? 'visibility' : 'visibility_off' }}</mat-icon
            >
            <mat-error i18n *ngIf="registerForm.get('password').hasError('required')">Пароль не задан</mat-error>
            <mat-error
              i18n
              *ngIf="
                !registerForm.get('password').hasError('required') && registerForm.get('password').hasError('minlength')
              "
              >Минимальная длина - {{ registerForm.get('password').getError('minlength').requiredLength }}</mat-error
            >
          </mat-form-field>

          <div class="terms flex justify-center items-center" *ngIf="options?.clientAgreement.contractUrl !== ''">
            <mat-checkbox #agreement name="terms" aria-label="I read and accept" formControlName="isReadContract">
              <span i18n>Я принимаю</span>
            </mat-checkbox>
            <a i18n [href]="options?.clientAgreement.contractUrl" target="_blank">соглашение</a>
          </div>

          <button
            i18n
            mat-raised-button
            color="accent"
            class="submit-button"
            aria-label="CREATE AN ACCOUNT"
            [disabled]="registerForm.invalid || !userId"
            >СОЗДАТЬ АККАУНТ</button
          >
        </form>
      </div>

      <div class="register flex-col" *ngIf="userId">
        <span i18n class="text">Уже зарегистрированы?</span>
        <a i18n class="link" [routerLink]="['/client/auth/login']" [queryParams]="{ user: userId }">Войти</a>
      </div>
    </div>
  </div>
</div>
